export const initialState = {
    status: false,
    search: '',
};
